export function LRTLogo({ className, style }: { className?: string; style?: React.CSSProperties }) {
    return (
        <svg
            style={style}
            className={className || 'h-full w-auto'}
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 4682.557 722.42"
            xmlns="http://www.w3.org/2000/svg"
            shapeRendering="geometricPrecision"
            role="presentation"
            aria-hidden="true"
        >
            <g transform="translate(-174.65 -393.93)">
                <path
                    d="M535.86 1116.35c-199.17 0-361.21-162.04-361.21-361.21s162.04-361.21 361.21-361.21 361.21 162.04 361.21 361.21-162.04 361.21-361.21 361.21m0-698.73c-186.11 0-337.52 151.41-337.52 337.51s151.41 337.51 337.52 337.51 337.51-151.41 337.51-337.51-151.41-337.51-337.51-337.51"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M640.02 815.6h-299.2V514.91h23.69V791.9h203.3V640.36h72.2c48.31 0 87.62 39.31 87.62 87.62.01 48.31-39.3 87.62-87.61 87.62m-48.51-23.69h48.51c35.25 0 63.93-28.68 63.93-63.93s-28.68-63.93-63.93-63.93h-48.51z"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M638.67 862.54H340.95v-23.69h297.73c61.13 0 110.86-49.73 110.86-110.87S699.8 617.12 638.67 617.12h-92.6v182.62h-23.69V593.42h116.29c74.19 0 134.56 60.36 134.56 134.56s-60.36 134.56-134.56 134.56"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path fill="var(--cms-ground)" d="M412.14 486.24v317.52h-23.69V486.24z" data-color="1"></path>
                <path fill="var(--cms-ground)" d="M546.07 850.69v206.53h-23.69V850.69z" data-color="1"></path>
                <path fill="var(--cms-ground)" d="M590.84 850.69v206.53h-23.69V850.69z" data-color="1"></path>
                <path fill="var(--cms-ground)" d="m683.27 840.55 66.438 132.742-21.185 10.603-66.438-132.742z" data-color="1"></path>
                <path fill="var(--cms-ground)" d="m722.033 821.42 59.952 117.465-21.1 10.77-59.953-117.466z" data-color="1"></path>
                <path
                    d="M535.86 441.21c-53.25 0-103.43 13.34-147.41 36.83v27.18c43.23-25.6 93.63-40.32 147.41-40.32 160.04 0 290.24 130.2 290.24 290.24s-130.2 290.24-290.24 290.24-290.24-130.2-290.24-290.24c0-96.07 46.76-181.25 118.89-234.1l.58-29.19c-86.11 56.04-143.16 153.12-143.16 263.3 0 173.1 140.83 313.93 313.93 313.93s313.93-140.83 313.93-313.93-140.83-313.94-313.93-313.94"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M1172.99 541.17c25.61-.06 51.16-.06 76.72 0 .06 119.85 0 239.76.06 359.66h186.68v64.36h-263.4c-.06-141.36-.06-282.66-.06-424.02"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M2071.81 541.17c55.83.11 111.65-.34 167.48.22 40.66.56 83.4 13.93 110.64 45.49 32.46 38.3 37.46 94.52 21.9 141.02-10.56 32.12-36.9 56.61-67.56 69.59 30.5 55.88 60.99 111.76 91.43 167.7-28.59-.06-57.17.06-85.76-.11-27.58-51.84-55.43-103.51-83.12-155.29h-78.29c0 51.84.06 103.62-.06 155.4-25.55-.06-51.11 0-76.61 0-.05-141.36-.05-282.66-.05-424.02m76.72 64.13v140.86c38.58-1.97 78.85 5.39 116.09-7.58 53.35-19.99 49.09-111.93-5.67-127.66-35.84-10.16-73.69-3.93-110.42-5.62"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path d="M2706.95 541.17c24.94-.06 49.87-.06 74.86 0-.06 141.36 0 282.66 0 424.03h-74.86z" fill="var(--cms-ground)" data-color="1"></path>
                <path
                    d="M2821.02 541.17h74.81c.06 141.3.06 282.66 0 424.03-24.99-.06-49.93.06-74.86-.06.05-141.36-.01-282.67.05-423.97"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M3324.34 541.17c112.77-.06 225.55 0 338.27-.06.06 21.45 0 42.91.06 64.36-43.69.11-87.39 0-131.08.06-.06 119.85.06 239.76 0 359.66-25.44-.06-50.83.06-76.16-.06 0-119.91.06-239.76 0-359.66-43.69.06-87.39 0-131.03.06-.06-21.51-.06-42.96-.06-64.36"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M4782.37 541.17c24.88 0 49.82-.06 74.81 0 0 141.36.06 282.66 0 424.03h-74.81c-.11-141.37-.05-282.67 0-424.03"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M3797.51 654.17c20.61-13.54 46.05-12.24 69.58-10.45 1.4 23.03.28 46.17.73 69.3-24.21-4.32-51.28-7.53-73.24 6.07-20.05 11.18-33.14 33.36-33.08 56.33-.51 63.24 0 126.53-.22 189.77-24.99-.11-49.98.22-74.92-.22.28-105.92 0-211.84.11-317.82 24.15 0 48.36-.06 72.62.06-.11 18.76-.45 37.46.73 56.27 7.93-19.38 18.77-38.81 37.69-49.31"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M1461.83 647.15h74.86c.06 63.52-.11 126.98 0 190.5-.45 20.56 6.85 42.57 24.09 54.98 28.59 20.78 73.01 10.78 91.94-18.53 9.66-13.76 11.91-31.06 11.79-47.46-.06-59.87-.06-119.68-.06-179.49h74.86c0 106.03.06 212.01 0 318.05-24.21 0-48.36-.06-72.56 0-.11-19.77.22-39.54-.45-59.25-12.02 22.24-27.97 43.86-51.95 54.08-38.81 16.4-88.74 11.91-119.63-18.37-23.2-22.52-32.46-55.6-32.8-87.16-.25-69.08-.03-138.22-.09-207.35"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M1760.34 647.2c26.45-.11 52.9 0 79.36-.06 21.68 38.98 42.35 78.57 64.53 117.27 21.34-39.26 43.3-78.18 64.92-117.27 26.4 0 52.79 0 79.19.06-31.9 52.96-63.8 105.87-95.76 158.83 32.46 53.07 65.04 106.03 97.44 159.16-26.28 0-52.51-.06-78.8 0-22.46-38.13-44.82-76.32-67.34-114.4-22.13 38.08-44.42 76.1-66.38 114.29-26.62.17-53.19.06-79.69.11 32.24-53.13 64.64-106.09 96.88-159.22-31.51-52.9-62.96-105.86-94.35-158.77"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M2485.06 650.85c43.47-12.47 92.78-11.06 133.44 9.94 30.78 15.61 50.27 49.14 50.49 83.46.56 73.63.06 147.31.17 220.94-23.98-.06-47.96 0-71.94 0-.11-15.22.06-30.33.06-45.44-13.87 20.22-31.68 39.26-56.11 46.11-34.43 9.66-73.74 7.47-104.91-10.95-52.96-30.5-57.29-120.86-3.26-152.31 43.36-26.12 95.93-21.23 143.61-31.96 27.91-6.01 19.32-45.77 1.97-59.14-33.53-23.14-88.74-11.06-103.9 28.87-23.25-3.15-46.45-6.4-69.64-9.77 10.49-38.41 41.94-68.85 80.02-79.75m.05 191.01c-23.36 12.92-24.49 51.44-1.35 65.09 33.47 19.32 83.57 9.32 102.78-25.61 11.68-20.33 6.96-44.59 8.03-66.83-34.82 15.67-75.93 8.37-109.46 27.35"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M2909.75 647.2c26.51-.06 53.07-.17 79.64.06 24.77 80.71 48.58 161.69 74.36 242 27.74-79.69 49.98-161.52 75.48-242.06 26.56-.11 53.13-.06 79.75 0-41 114.8-82.05 229.59-122.94 344.44-9.15 27.29-22.24 55.15-46.17 72.56-33.47 24.26-79.08 24.66-117.27 12.41 5.95-19.32 11.63-38.7 17.35-58.07 15.39 2.98 32.97 7.69 47.51-.95 16.23-9.83 21-29.37 27.58-45.77-38.46-108.22-76.87-216.45-115.29-324.62"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M3875.41 730.94c9.77-41.67 46.28-72.67 87.05-82.22 43.08-10.05 91.32-7.98 130.24 14.6 29.82 16.85 46.9 51.05 46.28 84.86.34 72.28 0 144.62.17 216.95-24.04.11-48.07.06-72.06.06.06-15.16-.06-30.33-.11-45.44-30.44 55.77-107.78 65.04-159.67 35.89-53.35-29.65-58.86-119.51-5.9-152.09 42.51-26.45 94.69-22.52 142.09-32.07 31.79-3.93 23.14-49.03 2.36-61.95-34.15-20.22-86.43-8.14-101.49 30.95-22.96-3.19-45.93-6.73-68.96-9.54m79.81 110.75c-24.09 13.14-24.66 53.13-.11 66.1 33.98 18.31 83.63 7.69 102.1-27.8 10.84-20.16 6.18-43.75 7.25-65.6-34.66 15.9-75.72 8.49-109.24 27.3"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M4151.5 647.2c26.68-.06 53.35-.06 80.03 0 23.03 74.86 46.39 149.67 69.3 224.59 1.35 4.55 3.43 8.82 6.18 12.8 25.22-78.91 49.37-158.21 73.97-237.34 26.56-.17 53.19-.11 79.81-.06-37.74 105.98-75.48 211.96-113.11 317.93-27.69.06-55.32.06-82.95 0-37.69-105.96-75.43-211.94-113.23-317.92"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
                <path
                    d="M4498.19 693.37c55.21-68.63 176.52-67.9 228.81 3.82 27.24 37.07 31.39 84.86 29.82 129.45-73.91.06-147.82-.06-221.67.06.51 27.58 10.28 57.4 34.48 73.07 36.51 23.81 97.33 16.46 114.68-27.86 23.2 2.58 46.45 5.17 69.64 7.98-9.83 41.9-45.21 74.13-86.27 84.69-45.21 11.57-96.15 9.49-137.04-14.6-35.83-21.12-58.8-59.53-65.82-99.97-9.48-53.53-2.23-113.62 33.37-156.64m71.61 20.67c-20.84 13.65-32.52 37.63-34.71 62 50.04.11 100.08.06 150.18.06-1.12-18.48-5.9-37.4-18.7-51.28-23.48-27.41-67.51-30.33-96.77-10.78"
                    fill="var(--cms-ground)"
                    data-color="1"
                ></path>
            </g>
        </svg>
    );
}

// Compact icon component using the lrt-icon.svg
export function LRTIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 722 722"
            className={className || 'h-full w-auto'}
            style={style}
            role="presentation"
            aria-hidden="true"
            shapeRendering="geometricPrecision"
        >
            <path
                d="M361,722C162,722,0,560,0,361S162,0,361,0s361,162,361,361-162,361-361,361M361,24C175,24,24,175,24,361s151,337,337,337,338-151,338-337S547,24,361,24"
                fill="currentColor"
            />
            <path
                d="M465,422H166V121h24v277h203V246h72c48,0,88,39,88,88s-39,88-88,88M417,398h49c35,0,64-29,64-64s-29-64-64-64h-49v128Z"
                fill="currentColor"
            />
            <path d="M464,469H166v-24h298c61,0,111-50,111-111s-50-111-111-111h-93v183h-24V182h116c74,0,135,60,135,135s-60,135-135,135" fill="currentColor" />
            <path d="M237,92v318h-24V92h24Z" fill="currentColor" />
            <path d="M371,457v207h-24V457h24Z" fill="currentColor" />
            <path d="M416,457v207h-24V457h24Z" fill="currentColor" />
            <path d="M509,447l66,133-21,11-66-133,21-11Z" fill="currentColor" />
            <path d="M547,427l60,118-21,11-60-118,21-11Z" fill="currentColor" />
            <path
                d="M361,47c-53,0-103,13-147,37v27c43-26,94-40,147-40,160,0,290,130,290,290s-130,290-290,290S71,521,71,361c0-96,47-181,119-234l1-29C104,154,47,251,47,361c0,173,141,314,314,314s314-141,314-314S534,47,361,47"
                fill="currentColor"
            />
        </svg>
    );
}

// Optimized Logo component for admin panel login/signup pages
export function AdminLogo() {
    return (
        <div className="flex justify-center">
            <LRTLogo className="h-20 w-auto max-w-xs" style={{ height: '60px' }} />
        </div>
    );
}

// Optimized Icon component for admin panel navigation using the compact icon
export function AdminIcon() {
    return (
        <div className="flex items-center justify-center p-1" style={{ height: '24px', width: '24px' }}>
            <LRTIcon className="h-full w-full" style={{ height: '24px', width: '24px', maxHeight: '24px', maxWidth: '24px' }} />
        </div>
    );
}
